/**
 * Frontend API Client
 * Re-exports domain-specific API modules as a unified `api` object.
 */

export { API_BASE, getAuthHeaders, fetchJson } from './client';

import { project } from './projectApi';
import { file } from './fileApi';
import { tile } from './tileApi';
import { potree } from './potreeApi';
import { photo } from './photoApi';
import { floorPlan } from './floorPlanApi';
import { s3 } from './s3Api';
import { auth } from './authApi';
import { admin } from './adminApi';
import { portal } from './portalApi';
import { share } from './shareApi';
import { upload } from './uploadApi';
import { convert } from './convertApi';

export const api = {
  project,
  file,
  tile,
  potree,
  photo,
  floorPlan,
  s3,
  auth,
  admin,
  portal,
  share,
  upload,
  convert,
};
